import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  Pagination,
  Paper,
  PaperProps,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import PageSizeSelection from "../../features/entrez/PageSizeSelection";
import Draggable from "react-draggable";
import CheckboxButtons from "./checkboxButton";
import { PaginationData } from "../models/db";
import FullScreenDialog from "../../features/entrez/FullScreenTableView";
import { CSVLink } from "react-csv";
import Title from "./Title";
import DownloadLink from "react-download-link";
import { entrezDbSelectors } from "../store/entrezDbSlice";
import { getFinalQueryAxiosParams } from "../store/storeHelper";
import { useAppDispatch, useAppSelector } from "../store/configureStore";
import { getRetStart } from "../util/util";
import agent from "../api/agentEntrez";
import { LoadingButton } from "@mui/lab";
import { entrezConfig } from "../util/entrezConfig";

interface Props {
  paginationData: PaginationData;
  allColumns: string[];
  selectedColumns: string[];
  dataRecords: any;
  selectedDB: string;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  onApplySelectedColumns: (selectedColumns: string[]) => void;
}

function PaperComponent(props: PaperProps) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function AppPagination({
  paginationData,
  allColumns,
  selectedColumns,
  dataRecords,
  selectedDB,
  onPageChange,
  onPageSizeChange,
  onApplySelectedColumns,
}: Props) {
  const { currentPage, totalCount, totalPages, pageSize } = paginationData;
  const [open, setOpen] = useState(false);

  // var arr: string[] = [];
  const [userSelectedColumns, setSelectedColumns] = useState(selectedColumns);

  const { dbParams } = useAppSelector((state) => state.entrezDb);

  //dbParams.db must be set before reaching here.
  const selectedDbWithItsState = useAppSelector((state) =>
    entrezDbSelectors.selectById(state, dbParams.db)
  );

  useEffect(() => {
    console.log("useEffect of pagination control");
    setSelectedColumns(selectedColumns);
  }, [selectedColumns]);

  if (totalCount <= 0) return <></>;

  const handleSelectedColumnChange = (cols: string[]) => {
    // dispatch(setProductParams({ types: items }))
    console.log("from handleSelectedColumnChange");
    console.log(cols);
    setSelectedColumns(cols);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApply = () => {
    onApplySelectedColumns(userSelectedColumns);
    setOpen(false);
  };

  const handleToggleAll = () => {
    if (userSelectedColumns.length == allColumns.length) {
      console.log("uncheck all");
      setSelectedColumns(["uid"]);
    } else {
      console.log("check all");
      setSelectedColumns([...allColumns]);
    }
  };

  const getDataFromURL = (url: string) =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        var finalQueryParams = {
          db: dbParams.db,
          querykey: selectedDbWithItsState!.eSearchResult!.querykey,
          webenv: selectedDbWithItsState!.eSearchResult!.webenv,
          retmax: selectedDbWithItsState!.paginationData!.pageSize,
          retstart: getRetStart(
            selectedDbWithItsState!.paginationData.currentPage,
            selectedDbWithItsState!.paginationData.pageSize
          ),
          retmode: "text",
          rettype: "medline",
        };

        const params = getFinalQueryAxiosParams(finalQueryParams);

        var response = agent.Entrez.getSearchResultDetailsMedlineFormat(params);
        console.log(response);
        resolve(response);
      }, 100);
    });

  const dStyles = {
    color: "black",
  };
  //const date = new Date();
  // let currentdate = date.toLocaleDateString();
  // let currenttime = date.toLocaleTimeString();
  //let currenttime = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
  //let currentdate = `${date.getFullYear()}/${date.getMonth()}/${date.getDate()}`;
  //const fileName = "ncbi_records_" + selectedDB + "_" + currentdate + "_" + currenttime + ".csv";
  //today.toLocaleString("en-US");
  //toUTCString().replace(',','')
  let today = new Date();
  const fileName =
    "ncbi_records_" +
    selectedDB +
    "_" +
    today.toUTCString().replace("GMT", "") +
    ".csv";

  const fileNameMedline =
    "ncbi_medrecords_" +
    selectedDB +
    "_" +
    today.toUTCString().replace("GMT", "") +
    ".txt";

  // flex-end
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box display="flex" alignItems="left">
        <Typography
          sx={{ padding: 1 }}
          component="h2"
          variant="body1"
          color="primary"
        >
          Per page
        </Typography>
        <PageSizeSelection
          onPageSizeSelection={onPageSizeChange}
        ></PageSizeSelection>

        <Typography
          sx={{ padding: 1 }}
          marginLeft={5}
          component="h2"
          variant="body1"
          color="primary"
        >
          Displaying: {(currentPage - 1) * pageSize + 1}-
          {currentPage * pageSize > totalCount
            ? totalCount
            : currentPage * pageSize}{" "}
          of {totalCount}
        </Typography>

        {/* Columns Selection */}

        <Box sx={{ ml: 5 }}>
          <Button variant="contained" size="small" onClick={handleClickOpen}>
            Select Columns
          </Button>
          <Dialog
            maxWidth="xl"
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
              Select Columns
            </DialogTitle>
            <DialogContent>
              {/* Check boxes for all columns */}
              <CheckboxButtons
                key={userSelectedColumns.length.toString()}
                items={allColumns}
                checked={userSelectedColumns}
                onChange={handleSelectedColumnChange}
              ></CheckboxButtons>
              {/* <DialogContentText>
                .some text to help 
              </DialogContentText> */}
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" onClick={handleToggleAll}>
                Toggle All
              </Button>
              <Button variant="contained" onClick={handleApply}>
                Apply
              </Button>
              <Button variant="contained" onClick={handleClose}>
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </Box>

        {/* end of column selections */}
      </Box>

      <Box display="flex" alignItems="left">
        {/* <Link sx={{ mr: 10, mt: 3 }}> */}
        {/* <div {...dStyles}> */}

        {/* https://www.npmjs.com/package/react-download-link */}
        {/* <LoadingButton loading> */}

        {entrezConfig.PublicationDateEligibleDbs.includes(dbParams.db) && (
          <DownloadLink
            style={{ color: "purple" }}
            label="Download MEDLINE Format"
            filename={fileNameMedline}
            exportFile={() => Promise.resolve(getDataFromURL(""))}
          ></DownloadLink>
        )}

        {/* </LoadingButton> */}

        <CSVLink
          //data={dataRecords}
          // headers={selectedColumns}

          data={dataRecords}
          filename={fileName}
        >
          <Link sx={{ mr: 10, ml: 3 }}>Download</Link>
        </CSVLink>
        {/* </div> */}
        {/* </Link> */}
        <Pagination
          showFirstButton
          showLastButton
          count={totalPages}
          page={currentPage}
          onChange={(event, page) => onPageChange(page)}
          color="primary"
          size="small"
        />
      </Box>
    </Box>
  );
}